module.exports = __webpack_public_path__ + "static/fcra-fin-2015-16-0dfea77df2c5ba90899ae8af496828fa.pdf";